import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

// '{
//     "brandId" :1,
//     "limit" :5,
//     "offset" : 0,
//     "startDate" :"2025-12-22T13:31:12Z",
//     "endDate" :"2025-12-22T13:31:12Z",
//     "templateTypeIn" :["TEXT", "IMAGE"],
//     "templateIds" :[1,2],
//     "statusIn" : ["SCHEDULED","RUNNING","LOW_PROMO_BALANCE","DONE", "CANCEL"]
// }'
export const getPromotionList = (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/notification/api/secure/v1/promotion-list",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// {
//     "brandTemplateId" :1,
//     "customerIdList" :[1,2],
//     "startOn" :"2025-12-24T23:55:00Z"
// }'
export const addPromotion = (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/notification/api/secure/v1/promotion",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addPromotionRegister = (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/notification/api/secure/v1/promotion-register",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// export const addPromotionRegisterWithId = (data, promotionId) => {
//   return axios({
//     method: "post",
//     url: STORE_BASE_URL + "/notification/api/secure/v1/promotion-register/" + promotionId,
//     headers: getHeaders(),
//     data: JSON.stringify(data),
//   });
// }; // multipart


export const addPromotionRegisterWithId = (fileData, promotionId) => {
  const formData = new FormData();
  formData.append("fileData", fileData); // Assuming 'file' is the file object you want to upload

  return axios({
    method: "post",
    url:
      STORE_BASE_URL + "/notification/api/secure/v1/promotion-register/" + promotionId,
    data: formData,
    headers: getHeaders("multipart/form-data"),
  });
};

// {
//     "brandPromotionId" :1,
//     "brandTemplateId" :1,
//     "customerIdList" :[1,2],
//     "startOn" :"2025-12-26T23:55:00Z"
// }'

export const updatePromotion = (data) => {
  return axios({
    method: "put",
    url: STORE_BASE_URL + "/notification/api/secure/v1/promotion",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getViewPromoTemplate = async (brandId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL + "/notification/api/secure/v1/promo-template/" + brandId, // for android use

    headers: getHeaders(),
  });
};

export const getBrandWhatsappConfig = async (brandId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL + "/store/api/secure/v1/brand/" + brandId + "/whatsapp-config", // for android use

    headers: getHeaders(),
  });
};

export const viewPromotionCustomer = async (data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL + "/notification/api/secure/v1/promotion-customer", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getPromotionCheckFailedCredit = async (promotionId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL + "/notification/api/secure/v1/promotion/" + promotionId + "/check-failed-credit", // for android use
    headers: getHeaders(),
  });
};


export const getPromotionAddFailedCredit = async (promotionId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL + "/notification/api/secure/v1/promotion/" + promotionId + "/add-failed-credit", // for android use
    headers: getHeaders(),
  });
};


